import { deepClone } from '@cf-shared/deep-helpers';
import { Log_WorkoutSet } from '@cf-shared/data-model/log-workout';

/**
 * #6694: what a reopened done set recorded when its edit began, so the collapse arrow can fold it back
 * WITHOUT saving. It holds everything an edit can change on the set: the whole `stats` (weight, reps,
 * unit, and the strength figures #4556 recomputes while the numbers change), the mini-sets, and which
 * weight and reps those strength figures came from.
 */
export interface SetEditSnapshot {
  stats: Log_WorkoutSet['stats'];
  miniSets: Log_WorkoutSet['miniSets'];
  derivedStatsFrom?: { weight_kg: number; reps: number };
}

/** copies what the set records now; the copy shares nothing with the live set */
export function takeSetEditSnapshot(logSet: Log_WorkoutSet, derivedStatsFrom?: { weight_kg: number; reps: number }): SetEditSnapshot {
  return {
    stats: deepClone(logSet.stats),
    miniSets: logSet.miniSets ? deepClone(logSet.miniSets) : undefined,
    derivedStatsFrom: derivedStatsFrom ? { ...derivedStatsFrom } : undefined,
  };
}

/** puts the snapshot back onto the set; the set keeps no object of the snapshot's */
export function restoreSetEditSnapshot(logSet: Log_WorkoutSet, snapshot: SetEditSnapshot): void {
  logSet.stats = deepClone(snapshot.stats);
  // if the set had no mini-sets when the edit began, it has none again
  if (snapshot.miniSets) {
    logSet.miniSets = deepClone(snapshot.miniSets);
  } else {
    delete logSet.miniSets;
  }
}
